module.exports = __webpack_public_path__ + "img/enterprise-main07.854431cf.jpg";